export default __webpack_public_path__ + "static/media/logo_razorpay.35ce7407.png";